export enum Audience {
    DRIVER = 'DRIVER',
    USER = 'CUSTOMER', // backend audience enums use 'CUSTOMER' for app users
    COMPANY_DRIVERS = 'COMPANY_DRIVERS' // drivers of one company (company id required)
}
